<script lang="ts">
	import { serializeScriptValue } from "@fergmar/ui/script";
	import type { PageProps } from "./$types";
	import {
		SubHeroMetrics,
		FAQ,
		CitySpecificContent,
		WeWantYourHouse,
		HomePageHero,
		FreeQuote
	} from "#lib/web-ui/home-buyers-template/content/index.js";
	import { getTemplateContext } from "#lib/web-ui/home-buyers-template/template-context.svelte.js";

	let { data }: PageProps = $props();

	const templateContext = getTemplateContext();

	const citySlug = $derived(data.city.toLowerCase().replace(/\s+/g, "-"));
	const pageUrl = $derived(`${templateContext.siteUrl}${data.state.toLowerCase()}/${citySlug}/`);
	const pageTitle = $derived(
		`Sell My House Fast in ${data.city}, ${data.state.toUpperCase()} - ${templateContext.siteName}`
	);
	const pageDescription = $derived(
		`Need to sell your house fast in ${data.city}, ${data.state.toUpperCase()}? ${templateContext.siteName} buys homes for cash with no fees, fast closing, and we buy as-is. Get your free offer today!`
	);

	const cityPageJsonLd = $derived({
		"@context": "https://schema.org",
		"@type": "WebPage",
		"@id": `${pageUrl}#webpage`,
		url: pageUrl,
		name: pageTitle,
		description: pageDescription,
		isPartOf: { "@id": `${templateContext.siteUrl}#website` },
		about: { "@id": `${templateContext.siteUrl}#organization` },
		inLanguage: "en-US",
		breadcrumb: {
			"@type": "BreadcrumbList",
			itemListElement: [
				{
					"@type": "ListItem",
					position: 1,
					name: "Home",
					item: templateContext.siteUrl
				},
				{
					"@type": "ListItem",
					position: 2,
					name: data.state.toUpperCase(),
					item: `${templateContext.siteUrl}${data.state.toLowerCase()}/`
				},
				{
					"@type": "ListItem",
					position: 3,
					name: data.city,
					item: pageUrl
				}
			]
		}
	});
</script>

<svelte:head>
	<title>{pageTitle}</title>
	<meta name="description" content={pageDescription} />

	<!-- Open Graph -->
	<meta property="og:type" content="website" />
	<meta property="og:title" content={pageTitle} />
	<meta property="og:description" content={pageDescription} />
	<meta property="og:url" content={pageUrl} />

	<svelte:element this={"script"} type="application/ld+json">
		{serializeScriptValue(cityPageJsonLd)}
	</svelte:element>
</svelte:head>

<HomePageHero />
<SubHeroMetrics />
<WeWantYourHouse />
<CitySpecificContent city={data.city} state={data.state} />
<FreeQuote />
<FAQ />
